<template>
  <div :class="get_css_classes">

    <slot></slot>
  </div>
</template>


<style scoped lang="scss" >
  @import '../assets/styles/variables/Variables';


  .base{
    /*margin:0;*/
    /*padding:10px;*/

    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: center;*/

  }

  .section-theme-dark{
    color: rgba(255, 255, 255, 1);
    background-color: $color-section-bg-dark;
  }

  .section-theme-light{
    color: rgb(0, 0, 0);
    background-color: $color-section-bg-light;
  }


  .section-transparent{
    background: none !important;

  }





</style>
<script>
export default {
  name: 'Section',
   data: () => ({
      test: 1
   }),



   props:{
      transparent: Boolean,
      background: String,

   },

   computed: {
     get_css_classes(){

        let ans = 'base';


        switch (this.background){
           case 'black':
              ans += ' section-theme-dark';
              break;

           case 'white':
              ans += ' section-theme-light';
              break;

           default:
              throw Error('background must be one of white or black.  passed in value was ' + this.background.toString());
        }

        if (this.transparent === true){
           ans += ' section-transparent';
        }

        return ans;
     },

   },

   created(){
     if (this.background === undefined){
        throw Error('prop background must be specified')
     }
   }
};
</script>
